import { createAppRequest } from '@/services/request';
import { BizAppConfig } from 'config/application.manifest';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsPortfolioPanoramaQueryParams,
  FamsPortfolioPanoramaResponse,
} from './types/portfolio-panorama';

const request = createAppRequest();

const withAppApiBaseUrl = (url: string) => {
  const baseUrl =
    BizAppConfig.appApiUrl ||
    (typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1'].includes(window.location.hostname) &&
    window.location.port === '8000'
      ? 'http://localhost:3004'
      : '');
  if (!baseUrl) return url;
  return `${baseUrl.replace(/\/+$/g, '')}${url}`;
};

export async function getFamsPortfolioPanorama(
  params?: FamsPortfolioPanoramaQueryParams,
  options?: ApiRequestOptions,
) {
  return request<FamsPortfolioPanoramaResponse>(
    withAppApiBaseUrl('/bff/fams/portfolio-panorama'),
    {
      method: 'GET',
      params,
      ...(options || {}),
    },
  );
}
